import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Modal from '@mui/material/Modal';
import { Box, IconButton, Tab, Tabs } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import InfiniteScrollModal from './InfiniteScroll';
import NoData from './Nodata';
import InputField from './Input';

import { useAppSelector, RootState } from '../redux/store';

import {
  setSelectedStudio,
  setSelectedTab,
  setSelectedEntity,
  setCommonMenu,
  removeBreadCrumbs,
  setAccordion,
  setBreadCrumbs,
  removeSpendingBreadCrumbs,
  setSpendingBreadCrumbs,
  setSelectedEntityType,
  setRiskBreadCrumbs,
  removeRiskBreadCrumbs,
  getRiskAnalystUser,
  getPermissions,
} from '../redux/commonSlice';

import Images from '../Utils/images';

import '../../src/Pages/Dashboard/production/production.scss';
import CustomTabPanel from './CustomTabPanel';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../helpers/contants';
import { dataSetter, formattedDate } from '../Utils/helperFns';
import ToolTipComponent from './ToolTipComponent';
import endPoints from '../api/endpoint';
import { useListing } from '../hooks/useListing';

const ChangeStudioModal = ({ open, handleClose, data }: any) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [searchTerm, setSearchTerm] = useState('');
  const [searchTimeout, setSearchTimeout] = useState<any>(null);
  const [productions, setProductions] = useState();
  const [episodes, setEpisodes] = useState();
  const [sets, setSets] = useState();
  const [locations, setLocations] = useState();
  const [studios, setStudios] = useState();

  const { selectedTab, selectedEntity, accessDashboards, isRiskAnalystUser } =
    useAppSelector((state: RootState) => state.common);

  const [value, setValue] = React.useState(selectedTab || 0);
  const [filter, setFilter] = useState<any>({
    page: 1,
    limit: 12,
    searchKey: '',
  });

  const {
    fetchListing,
    data: favorites,
    hasMore: hasMoree,
    loading: loadinggg,
    setData,
    setLoading,
  } = useListing<any>({
    url:
      value === 0
        ? endPoints.studio.AllStudiolist
        : value === 1
        ? endPoints.production.productionDashList
        : value === 2
        ? endPoints.episode.episodeDashList
        : value === 3
        ? endPoints.set.setDashList
        : endPoints.location.locationDashList, // Always use setList for other productions

    params: {
      page: filter.page,
      limit: value === 4 ? 10 : 12,
      searchKey: filter.searchKey,
    },
    isPopupSet: value === 3,
    isPopupProduction: value === 1,
    isPopupEpisode: value === 2,
    isPopupLocations: value === 4,
    isPopupStudio: value === 0,
    isInfinite: true,
    setProductions,
    setLocations,
    setSets,
    setEpisodes,
    setStudios,
  });

  const loadMore = () => {
    if (!loadinggg && hasMoree) {
      setFilter({
        ...filter,
        page: filter.page + 1,
      });
    }
  };

  useEffect(() => {
    fetchListing();
  }, [filter]);

  /**
   * Handles tab change event and updates filter value to reflect new tab data.
   * @example
   * handleTabChangeEvent(sample_event, sample_newValue)
   * No return value, modifies component's state.
   * @param {React.SyntheticEvent} event - Event triggered by tab change.
   * @param {number} newValue - Integer representing the new active tab index.
   * @returns {void} Does not return a value, modifies state and initiates data fetching.
   * @description
   *   - Resets the local component state for data to an empty array.
   *   - Sets loading state to true indicating that data fetching is in progress.
   *   - Updates filter object with new tab index and resets the page index.
   */
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    // setSearchTerm('')
    setData([]);
    setLoading(true);
    setFilter({
      ...filter,
      value: newValue,
      page: 1,
      // searchKey: '',
    });
    // setLoading(false);
    setValue(newValue);
    // setPageNo(1);
    // setHasMore(true);
    // setSearchTerm('');

    // fetchMoreData(true, '' || '', newValue); // Ensure data is fetched for the new tab
  };

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const formatNames = (arr: string[] | any, type?: string) => {
    if (!arr || arr.length === 0) return { text: '', extraCount: 0 };
    if (arr.length <= 2) return { text: arr.join(', '), extraCount: 0 };

    if (type) {
      return { text: `${arr[0]}`, extraCount: arr.length - 2 };
    }
    return { text: `${arr[0]}, ${arr[1]}`, extraCount: arr.length - 2 };
  };

  //debounce : search after 500ms of typing
  /**
   * Processes an input event for searching and updates application state accordingly.
   * @example
   * handleInputChange(event)
   * // No specific return value as changes occur in component state.
   * @param {Object} e - Event object from the input field, containing value to be processed.
   * @returns {void} Doesn't return a value as it modifies internal state and triggers other functions.
   * @description
   *   - Trims leading spaces from input value to ensure valid search queries.
   *   - Delays search execution to optimize performance using setTimeout.
   *   - Resets search results when input is empty or query length is below threshold.
   *   - Sets key for search and updates filter for pagination.
   */
  const handleSearchChange = (e: any) => {
    const trimmedValue = e.target.value.trimStart();

    // Prevent setting query with only spaces
    if (trimmedValue.length === 0 && e.target.value !== '') {
      return;
    }
    clearInterval(searchTimeout);
    if (e.target.value.trimStart().length > 2 || searchTerm.length === 0) {
      setSearchTimeout(
        setTimeout(() => {
          // handleSearch(e.target.value.trimStart());
          setFilter({
            ...filter,
            searchKey: e.target.value.trimStart(),
            page: 1,
          });
          // setQuery(e.target.value.trimStart())
        }, 500),
      );
    }
    if (!e.target.value || searchTerm.length === 0) {
      setSearchTimeout(
        setTimeout(() => {
          setData([]);
          // handleSearch(e.target.value.trimStart());
          setFilter({
            ...filter,
            searchKey: e.target.value.trimStart(),
            page: 1,
          });
        }, 500),
      );
    }
    setSearchTerm(e.target.value.trimStart());
  };

  /**
   * Configures breadcrumb navigation based on the provided entity type and data.
   * @example
   * configureBreadcrumbs('studio', {name: 'Studio 1'}, '/redirect/path')
   * // Breadcrumb navigation is set for 'Studio 1'.
   * @param {string} type - The type of the entity, such as 'studio' or 'location'.
   * @param {any} entityData - An object containing data about the entity, including name and possibly address.
   * @param {string} redirect - The path to which the breadcrumbs should redirect.
   * @returns {void} Does not return a value.
   * @description
   *   - Updates breadcrumbs by removing existing ones and setting new ones based on the entity type and data.
   *   - If the entity type is 'location', the breadcrumb title uses the location's name instead of the entity's name.
   *   - Assumes the existence of helper functions like removeBreadCrumbs() and setBreadCrumbs().
   */
  const handleDetailRedirection = (
    type: string,
    entityData: any,
    redirect: string,
  ) => {
    removeBreadCrumbs();
    const data = [
      {
        current: 0,
        name: type,
        type: 'dashboard',
        title:
          type !== 'location'
            ? type === 'episode'
              ? `${
                  entityData?.episodeNumber
                    ? entityData?.episodeNumber + ' - '
                    : ''
                }${entityData?.name}`
              : entityData?.name
            : entityData?.address?.locationName,
        path: redirect,
        selectedEntity: entityData,
      },
    ];

    setBreadCrumbs(data);
    // navigate(`${ROUTES.PRODUCTION_DETAIL}/${productiondetails?._id}`);
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="modal-main"
    >
      <div className="modal-dialog large">
        <div className="modal-content">
          <div className="modal-title d-flex flex-between align-center">
            <p className="title text-gray_700 fw500">
              Change{' '}
              {value === 0
                ? 'Studio/Prod Co.'
                : value === 1
                ? 'Project'
                : value === 2
                ? 'Episode/Event'
                : value === 3
                ? 'Set/Activity'
                : 'Location'}
            </p>
            <button onClick={handleClose} className="blank-btn">
              <i className="cross-icon"></i>
            </button>
          </div>
          <div className="modal-body">
            <div className="search">
              <InputField
                id="search"
                placeholder={
                  value === 0
                    ? 'Search Studio/Prod Co.'
                    : value === 1
                    ? 'Search Projects'
                    : value === 2
                    ? 'Search Episode/Event'
                    : value === 3
                    ? 'Search Set/Activity'
                    : 'Search Location'
                }
                name="search"
                value={searchTerm}
                onChange={handleSearchChange}
                onKeyDown={e => {
                  if (e.key === 'Enter') {
                    if (searchTerm.trim()) {
                      setFilter({
                        ...filter,
                        searchKey: searchTerm.trim(),
                        page: 1,
                      });
                    } else {
                      setFilter({
                        ...filter,
                        searchKey: '',
                        page: 1,
                      }); // Call with empty searchTerm
                    }
                  }
                }}
                endAdornment={
                  <div className="inputEndIcon">
                    {searchTerm && (
                      <IconButton
                        color="primary"
                        sx={{ p: '10px' }}
                        aria-label="clear"
                        onClick={() => {
                          setData([]);
                          setSearchTerm('');
                          setFilter({
                            ...filter,
                            searchKey: '',
                            page: 1,
                          });
                        }}
                      >
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    )}
                    <IconButton
                      color="primary"
                      sx={{ p: '10px' }}
                      aria-label="search"
                      onClick={() => {
                        setFilter({
                          ...filter,
                          searchKey: searchTerm,
                          page: 1,
                        });
                      }}
                    >
                      <img src={Images.SEARCH_BLACK} alt="search" />
                    </IconButton>
                  </div>
                }
              />
            </div>
            <div className="r_tabs">
              <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    aria-label="basic tabs example"
                    variant="scrollable"
                    centered
                    scrollButtons={false}
                    allowScrollButtonsMobile
                  >
                    <Tab label="My Studio/Prod Co." {...a11yProps(0)} />
                    {location?.pathname !== '/risk' && (
                      <Tab label="My Projects/Live Events" {...a11yProps(1)} />
                    )}
                    {location?.pathname !== '/risk' && (
                      <Tab label="My Episodes/Events" {...a11yProps(2)} />
                    )}
                    {location?.pathname !== '/risk' && (
                      <Tab label="My Sets/Activities" {...a11yProps(3)} />
                    )}
                    {location?.pathname !== '/risk' && (
                      <Tab label="My Locations" {...a11yProps(4)} />
                    )}
                  </Tabs>
                </Box>
                <CustomTabPanel value={value} index={0}>
                  <InfiniteScrollModal
                    fetchMoreData={loadMore}
                    hasMore={hasMoree}
                    loading={loadinggg}
                    className="change_studio"
                  >
                    <div className="img-cards pb-20">
                      {studios?.length > 0 ? (
                        studios?.map((department: any, index: any) => (
                          <div
                            key={index}
                            onClick={async () => {
                              removeBreadCrumbs();
                              if (window.innerWidth <= 1024) {
                                dispatch(setCommonMenu(false));
                              }

                              if (
                                department?._id &&
                                department?.memberType !== 'OWNER'
                              ) {
                                getRiskAnalystUser(department?._id, 'studio');
                              }

                              document.body.classList.remove('body-freeze');
                              dispatch(setAccordion(false));

                              dispatch(setSelectedStudio(department));
                              dispatch(setSelectedEntity(department));

                              dispatch(setSelectedTab(value));
                              // dataSetter(
                              //   'selectedStudio',
                              //   JSON.stringify(department)
                              // )
                              dataSetter('selectedTab', JSON.stringify(value));
                              handleClose();
                              removeRiskBreadCrumbs();
                              removeSpendingBreadCrumbs();
                              const studio = [
                                {
                                  name: 'studio',
                                  type: 'studio dashboard',
                                  title: department?.name,
                                  path: '/studio-dashboard',
                                },
                              ];
                              setSpendingBreadCrumbs(studio);
                              let hasRiskAccessForThisStudio = false;
                              try {
                                hasRiskAccessForThisStudio =
                                  await getRiskAnalystUser(
                                    department?._id,
                                    'studio',
                                  );
                              } catch {
                                hasRiskAccessForThisStudio = false; // fallback
                              }

                              if (location.pathname !== '/risk') {
                                if (
                                  // accessDashboards?.hasRiskCentrePermission ||
                                  hasRiskAccessForThisStudio
                                ) {
                                  dispatch(setSelectedEntityType('studio'));
                                  const studio = [
                                    {
                                      name: 'studio',
                                      type: 'studio risk dashboard',
                                      title: data?.name,
                                      path: `${ROUTES.RISK_CENTER}?studioId=${department?._id}&name=${department?.name}`,
                                    },
                                  ];

                                  setRiskBreadCrumbs(studio);
                                  getPermissions(
                                    'studios',
                                    department?._id,
                                    department?.memberType,
                                  );

                                  navigate(
                                    `${ROUTES.RISK_CENTER}?studioId=${department?._id}&name=${department?.name}`,
                                  );
                                } else {
                                  dispatch(setSelectedEntityType('studio'));
                                  handleDetailRedirection(
                                    'studio',
                                    department,
                                    `${ROUTES.STUDIO_DASHBOARD}`,
                                  );
                                  navigate(ROUTES.STUDIO_DASHBOARD);
                                }
                              }
                            }}
                          >
                            <div
                              className="img-card cursor-pointer"
                              title={department?.name}
                            >
                              <img
                                src={
                                  department?.image
                                    ? department?.image
                                    : Images.VENDOR_PLACEHOLDER
                                }
                                alt={department.name}
                              />
                              <p>{department.name}</p>
                            </div>
                          </div>
                        ))
                      ) : !loadinggg ? (
                        <NoData title="No Studio/Prod Co. Found" />
                      ) : null}
                    </div>
                  </InfiniteScrollModal>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={1}>
                  <InfiniteScrollModal
                    fetchMoreData={loadMore}
                    hasMore={hasMoree}
                    loading={loadinggg}
                    className="change_studio"
                  >
                    <div className="img-cards  pb-20">
                      {productions?.length > 0 ? (
                        productions?.map((department: any, index: any) => (
                          <div
                            key={index}
                            onClick={async () => {
                              removeBreadCrumbs();
                              if (window.innerWidth <= 1024) {
                                dispatch(setCommonMenu(false));
                              }
                              if (
                                department?._id &&
                                department?.memberType !== 'OWNER'
                              ) {
                                getRiskAnalystUser(
                                  department?._id,
                                  'production',
                                );
                              }
                              document.body.classList.remove('body-freeze');
                              dispatch(setAccordion(false));

                              dispatch(setSelectedEntity(department));

                              dataSetter('selectedTab', JSON.stringify(value));
                              dispatch(setSelectedTab(value));
                              removeSpendingBreadCrumbs();
                              removeRiskBreadCrumbs();
                              const studio = [
                                {
                                  name: 'production',
                                  type: 'production dashboard',
                                  title: department?.name,
                                  path: `${ROUTES.PRODUCTION_DASHBOARD}?${department?._id}`,
                                },
                              ];
                              setSpendingBreadCrumbs(studio);
                              let hasRiskAccessForThisStudio = false;
                              try {
                                hasRiskAccessForThisStudio =
                                  await getRiskAnalystUser(
                                    department?._id,
                                    'production',
                                  );
                              } catch {
                                hasRiskAccessForThisStudio = false; // fallback
                              }

                              if (
                                // accessDashboards?.hasRiskCentrePermission ||
                                hasRiskAccessForThisStudio
                              ) {
                                // dispatch(setSelectedEntityType('production'));
                                const production = [
                                  {
                                    name: 'production',
                                    type: 'production risk dashboard',
                                    title: department?.name,
                                    path: `${ROUTES.PRODUCTION_SECURITY_DASHBOARD}?productionId=${department?._id}&name=${department?.name}`,
                                  },
                                ];
                                setRiskBreadCrumbs(production);
                                getPermissions(
                                  'productions',
                                  department?._id,
                                  department?.memberType,
                                );

                                navigate(
                                  `${ROUTES.PRODUCTION_SECURITY_DASHBOARD}?productionId=${department?._id}&name=${department?.name}`,
                                );
                              } else {
                                // dispatch(setSelectedEntityType('production'));
                                handleDetailRedirection(
                                  'production',
                                  department,
                                  `${ROUTES.PRODUCTION_DASHBOARD}?${department?._id}`,
                                );

                                navigate(
                                  `${ROUTES.PRODUCTION_DASHBOARD}?${department?._id}`,
                                );
                              }

                              handleClose();
                            }}
                          >
                            <div
                              className="img-card cursor-pointer"
                              title={department?.name}
                            >
                              <img
                                src={
                                  department?.image
                                    ? department?.image
                                    : department?.fallbackImage ||
                                      Images.VENDOR_PLACEHOLDER
                                }
                                alt={department.name}
                              />
                              <p>{department.name}</p>
                            </div>
                          </div>
                        ))
                      ) : !loadinggg ? (
                        <NoData title="No Projects Found" />
                      ) : null}
                    </div>
                  </InfiniteScrollModal>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={2}>
                  <InfiniteScrollModal
                    fetchMoreData={loadMore}
                    hasMore={hasMoree}
                    loading={loadinggg}
                    className="change_studio"
                  >
                    <div className="img-cards  pb-20">
                      {episodes?.length > 0 ? (
                        episodes?.map((department: any, index: any) => (
                          <div
                            className="d-flex"
                            key={index}
                            onClick={async () => {
                              removeBreadCrumbs();
                              if (window.innerWidth <= 1024) {
                                dispatch(setCommonMenu(false));
                              }
                              document.body.classList.remove('body-freeze');
                              dispatch(setAccordion(false));
                              if (
                                department?._id &&
                                department?.memberType !== 'OWNER'
                              ) {
                                getRiskAnalystUser(department?._id, 'episode');
                              }

                              dispatch(setSelectedEntity(department));
                              // dispatch(setSelectedEntityType('episode'));
                              dataSetter('selectedTab', JSON.stringify(value));
                              dispatch(setSelectedTab(value));
                              removeRiskBreadCrumbs();
                              removeSpendingBreadCrumbs();
                              const studio = [
                                {
                                  name: 'episode',
                                  type: 'episode dashboard',
                                  title: department?.episodeNumber
                                    ? `${
                                        department?.episodeNumber
                                          ? department?.episodeNumber + ' - '
                                          : ''
                                      }${department?.name}`
                                    : `${department?.name}`,
                                  path: `${ROUTES.EPISODE_DASHBOARD}?${department?._id}`,
                                },
                              ];
                              setSpendingBreadCrumbs(studio);

                              let hasRiskAccessForThisStudio = false;
                              try {
                                hasRiskAccessForThisStudio =
                                  await getRiskAnalystUser(
                                    department?._id,
                                    'episode',
                                  );
                              } catch {
                                hasRiskAccessForThisStudio = false; // fallback
                              }
                              if (
                                // accessDashboards?.hasRiskCentrePermission ||
                                hasRiskAccessForThisStudio
                              ) {
                                const episode = [
                                  {
                                    name: 'episode',
                                    type: 'episode risk dashboard',
                                    title: `${
                                      department?.episodeNumber
                                        ? department?.episodeNumber + ' - '
                                        : ''
                                    }${department?.name}`,
                                    path: `${ROUTES.EPIOSDE_SECURITY_DASHBOARD}?episodeId=${department?._id}&name=${department?.name}`,
                                  },
                                ];
                                getPermissions(
                                  'episodes',
                                  department?._id,
                                  department?.memberType,
                                );
                                setRiskBreadCrumbs(episode);
                                navigate(
                                  `${ROUTES.EPIOSDE_SECURITY_DASHBOARD}?episodeId=${department?._id}&name=${department?.name}`,
                                );
                              } else {
                                handleDetailRedirection(
                                  'episode',
                                  department,
                                  `${ROUTES.EPISODE_DASHBOARD}?${department?._id}`,
                                );
                                // dataSetter(
                                //   'selectedEpisode',
                                //   JSON.stringify(department)
                                // )
                                navigate(
                                  `${ROUTES.EPISODE_DASHBOARD}?${department?._id}`,
                                );
                              }

                              handleClose();
                            }}
                          >
                            <div className="modal-studio-card">
                              <img
                                src={
                                  department?.image
                                    ? department?.image
                                    : department?.fallbackImage
                                    ? department?.fallbackImage
                                    : Images.VENDOR_PLACEHOLDER
                                }
                                alt={department.name}
                              />
                              <div className="text">
                                <p
                                  className="text-gray_900 MuiTypography-subtitle1 ellipse fw600"
                                  title={`${
                                    department?.episodeNumber
                                      ? `${department?.episodeNumber} - `
                                      : ''
                                  }${department?.name}`}
                                >
                                  {department?.episodeNumber
                                    ? `${department?.episodeNumber} - `
                                    : ''}{' '}
                                  {department?.name}
                                </p>
                                <p className="text-text MuiTypography-subtitle1 fw400">
                                  {department?.productionName}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : !loadinggg ? (
                        <NoData title="No Episodes Found" />
                      ) : null}
                    </div>
                  </InfiniteScrollModal>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={3}>
                  <InfiniteScrollModal
                    fetchMoreData={loadMore}
                    hasMore={hasMoree}
                    loading={loadinggg}
                    className="change_studio"
                  >
                    <div className="img-cards  pb-20">
                      {sets?.length > 0 ? (
                        sets?.map((department: any, index: any) => (
                          <div
                            className="d-flex"
                            key={index}
                            onClick={async () => {
                              removeBreadCrumbs();
                              if (window.innerWidth <= 1024) {
                                dispatch(setCommonMenu(false));
                              }
                              document.body.classList.remove('body-freeze');
                              dispatch(setAccordion(false));
                              if (
                                department?._id &&
                                department?.memberType !== 'OWNER'
                              ) {
                                getRiskAnalystUser(department?._id, 'set');
                              }
                              dispatch(
                                setSelectedEntity({
                                  ...department,
                                  name: department?.name?.toUpperCase(),
                                }),
                              );
                              dispatch(setSelectedEntityType('set'));
                              dataSetter('selectedTab', JSON.stringify(value));
                              dispatch(setSelectedTab(value));
                              removeSpendingBreadCrumbs();
                              removeRiskBreadCrumbs();
                              const studio = [
                                {
                                  name: 'set',
                                  type: 'set dashboard',
                                  title: department?.name,
                                  path: `${ROUTES.SET_DASHBOARD}?${department?._id}`,
                                },
                              ];
                              setSpendingBreadCrumbs(studio);
                              let hasRiskAccessForThisStudio = false;
                              try {
                                hasRiskAccessForThisStudio =
                                  await getRiskAnalystUser(
                                    department?._id,
                                    'set',
                                  );
                              } catch {
                                hasRiskAccessForThisStudio = false; // fallback
                              }

                              if (
                                // accessDashboards?.hasRiskCentrePermission ||
                                hasRiskAccessForThisStudio
                              ) {
                                const set = [
                                  {
                                    name: 'set',
                                    type: 'set risk dashboard',
                                    title: `${department?.name?.toUpperCase()}`,
                                    path: `${
                                      ROUTES.SET_SECURITY_DASHBOARD
                                    }?setId=${
                                      department?._id
                                    }&name=${department?.name?.toUpperCase()}`,
                                  },
                                ];
                                getPermissions(
                                  'sets',
                                  department?._id,
                                  department?.memberType,
                                );
                                setRiskBreadCrumbs(set);
                                navigate(
                                  `${ROUTES.SET_SECURITY_DASHBOARD}?setId=${
                                    department?._id
                                  }&name=${department?.name?.toUpperCase()}`,
                                );
                              } else {
                                handleDetailRedirection(
                                  'set',
                                  department,
                                  `${ROUTES.SET_DASHBOARD}?${department?._id}`,
                                );
                                // dataSetter(
                                //   'selectedSet',
                                //   JSON.stringify(department)
                                // )
                                navigate(
                                  `${ROUTES.SET_DASHBOARD}?${department?._id}`,
                                );
                              }

                              handleClose();
                            }}
                          >
                            <div className="modal-studio-card">
                              <img
                                src={
                                  department?.image
                                    ? department?.image
                                    : department?.fallbackImage
                                    ? department?.fallbackImage
                                    : Images.VENDOR_PLACEHOLDER
                                }
                                alt={department.name}
                              />
                              <div className="text">
                                <p
                                  className="text-gray_900 fw600 MuiTypography-subtitle1 ellipse"
                                  title={department?.name?.toUpperCase()}
                                >
                                  {department?.name?.toUpperCase()}
                                </p>
                                <p className="text-text MuiTypography-subtitle1">
                                  {department?.productionName}
                                </p>
                                {department?.episodeName ? (
                                  <p className="text-gray_900 MuiTypography-subtitle3">
                                    {`${
                                      department?.episodeNumber
                                        ? `${department?.episodeNumber} - `
                                        : ''
                                    }${department?.episodeName}`}
                                  </p>
                                ) : null}
                                <p className="text-gray_900 MuiTypography-subtitle3 lh-14">
                                  {' '}
                                  {formattedDate(department?.schedule || [])}
                                </p>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : !loadinggg ? (
                        <NoData title="No Sets/Activity Found" />
                      ) : null}
                    </div>
                  </InfiniteScrollModal>
                </CustomTabPanel>
                <CustomTabPanel value={value} index={4}>
                  <InfiniteScrollModal
                    fetchMoreData={loadMore}
                    hasMore={hasMoree}
                    loading={loadinggg}
                    className="change_studio"
                    isLocation
                  >
                    <div className="location_cards pb-20">
                      {locations?.length > 0 ? (
                        locations?.map((department: any, index: any) => (
                          <div
                            key={index}
                            onClick={async () => {
                              removeBreadCrumbs();
                              if (window.innerWidth <= 1024) {
                                dispatch(setCommonMenu(false));
                              }
                              document.body.classList.remove('body-freeze');
                              dispatch(setAccordion(false));
                              if (
                                department?._id &&
                                department?.memberType !== 'OWNER'
                              ) {
                                getRiskAnalystUser(department?._id, 'location');
                              }

                              dispatch(setSelectedEntity(department));
                              dispatch(setSelectedEntityType('location'));
                              dataSetter('selectedTab', JSON.stringify(value));
                              dispatch(setSelectedTab(value));
                              removeSpendingBreadCrumbs();
                              removeRiskBreadCrumbs();

                              const studio = [
                                {
                                  name: 'location',
                                  type: 'location dashboard',
                                  title: department?.address?.locationName,
                                  path: `${ROUTES.LOCATION_DASHBOARD}?${department?._id}`,
                                },
                              ];
                              setSpendingBreadCrumbs(studio);

                              let hasRiskAccessForThisStudio = false;
                              try {
                                hasRiskAccessForThisStudio =
                                  await getRiskAnalystUser(
                                    department?._id,
                                    'location',
                                  );
                              } catch {
                                hasRiskAccessForThisStudio = false; // fallback
                              }

                              if (
                                // accessDashboards?.hasRiskCentrePermission ||
                                hasRiskAccessForThisStudio
                              ) {
                                const location = [
                                  {
                                    name: 'location',
                                    type: 'location risk dashboard',
                                    title: `${
                                      department?.address?.locationName ||
                                      department?.address?.nickname
                                    }`,
                                    path: `${ROUTES.LOCATION_SECURITY_DASHBOARD}?locationId=${department?._id}&name=${department?.address?.locationName}&memberType=${department?.memberType}`,
                                  },
                                ];
                                getPermissions(
                                  'locations',
                                  department?._id,
                                  department?.memberType,
                                );
                                setRiskBreadCrumbs(location);
                                navigate(
                                  `${ROUTES.LOCATION_SECURITY_DASHBOARD}?locationId=${department?._id}&name=${department?.address?.locationName}&memberType=${department?.memberType}`,
                                );
                              } else {
                                handleDetailRedirection(
                                  'location',
                                  department,
                                  ROUTES.LOCATION_DASHBOARD +
                                    '?' +
                                    department?._id,
                                );

                                navigate(
                                  `${ROUTES.LOCATION_DASHBOARD}?${department?._id}`,
                                );
                              }

                              handleClose();

                              dataSetter(
                                'selectedLocation',
                                JSON.stringify(department),
                              );
                            }}
                            className="locations"
                          >
                            <img
                              // src={department.image}
                              src={Images.PinIcon}
                              alt={department.address?.nickname || ''}
                            />
                            <div className="text">
                              <h3
                                title={
                                  department?.address?.locationName ||
                                  department?.address?.nickname
                                }
                                className="fw600"
                              >
                                {department?.address?.locationName ||
                                  department?.address?.nickname}
                              </h3>
                              <div>
                                <p className="text-text MuiTypography-subtitle2">
                                  {department?.productionName}{' '}
                                  {department?.setNames?.length
                                    ? (() => {
                                        const { text, extraCount } =
                                          formatNames(
                                            department?.setNames,
                                            'sets',
                                          );
                                        return (
                                          <>
                                            | {text.toUpperCase()}
                                            {extraCount > 0 ? (
                                              <ToolTipComponent
                                                theme="light"
                                                title={Object.entries(
                                                  department?.setNames,
                                                )
                                                  .slice(2) // Get all remaining key-value pairs
                                                  .map(
                                                    ([_, value]) => `${value}`,
                                                  )
                                                  .join(', ')}
                                              >
                                                <span className="MuiTypography-subtitle2 d-inline-block lh-14 ml-10 nowrap text-primary_blue_500">
                                                  +{extraCount}
                                                </span>
                                              </ToolTipComponent>
                                            ) : null}
                                          </>
                                        );
                                      })()
                                    : null}
                                </p>{' '}
                              </div>
                              {department?.locationPurpose?.length
                                ? (() => {
                                    const { text, extraCount } = formatNames(
                                      department?.locationPurpose,
                                    );
                                    return (
                                      <>
                                        <div className="d-flex">
                                          <p className="fw400 text-gray_800">
                                            {text}
                                          </p>
                                          {extraCount > 0 ? (
                                            <ToolTipComponent
                                              theme="light"
                                              title={Object.entries(
                                                department?.locationPurpose,
                                              )
                                                .slice(2) // Get all remaining key-value pairs
                                                .map(([_, value]) => `${value}`)
                                                .join(', ')}
                                            >
                                              <span className="MuiTypography-subtitle2 d-inline-block lh-14 ml-10 nowrap text-primary_blue_500">
                                                +{extraCount}
                                              </span>
                                            </ToolTipComponent>
                                          ) : null}
                                        </div>
                                      </>
                                    );
                                  })()
                                : null}
                              {/* {department?.address?.nickname && (
                                <p>
                                  <span>{department.address.nickname}</span>
                                </p>
                              )} */}
                            </div>
                          </div>
                        ))
                      ) : !loadinggg ? (
                        <NoData title="No Locations Found" />
                      ) : null}
                    </div>
                  </InfiniteScrollModal>
                </CustomTabPanel>
              </Box>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ChangeStudioModal;
